// ---------------------------------------------------------------------------
// MOCK DATA LAYER — Comunidade Águas Vivas Caratinga
// Structured to mirror the future NestJS + MySQL schema. When the real API is
// ready, `services/api.js` swaps mock reads for fetch() calls with no changes
// required in the UI components.
// ---------------------------------------------------------------------------

// People (supervisors, leaders, hosts). avatar uses pravatar (no API key).
const av = (n) => `https://i.pravatar.cc/240?img=${n}`;

// ---------------------------------------------------------------------------
// HOME SECTIONS — configuração dinâmica da página inicial.
// Cada seção é renderizada na Home conforme `type`, `order` e `visible`.
// ---------------------------------------------------------------------------
export const homeSections = [
  {
    id: 'hs-hero',
    type: 'hero',
    title: 'Banner principal',
    subtitle: 'Hero da página inicial',
    visible: true,
    order: 1,
    content: {
      badge: 'Comunidade Águas Vivas · Caratinga',
      title: 'Sua vida em comunidade',
      highlight: 'começa aqui.',
      subtitle: 'Somos uma família que cresce junta, ora junta e transforma a cidade com o amor de Cristo.',
      searchPlaceholder: 'Buscar pregações, células, eventos...',
      popularTags: ['#Fé', '#Comunhão', '#Mensagens', '#Células', '#Adoração'],
      heroImage: 'https://images.unsplash.com/photo-1517456793572-1d8efd6dc135?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
    },
  },
  {
    id: 'hs-stats',
    type: 'stats',
    title: 'Estatísticas',
    subtitle: 'Números da comunidade',
    visible: true,
    order: 2,
    content: {
      cards: [
        { label: 'Células ativas', value: 'cells', icon: 'map', tone: 'bg-primary-light text-primary' },
        { label: 'Redes de células', value: 'networks', icon: 'network', tone: 'bg-accent-light text-accent-dark' },
        { label: 'Membros ativos', value: '120+', icon: 'users', tone: 'bg-emerald-100 text-emerald-700' },
        { label: 'Eventos no mês', value: '4', icon: 'calendar', tone: 'bg-violet-100 text-violet-700' },
      ],
    },
  },
  {
    id: 'hs-next-event',
    type: 'nextEvent',
    title: 'Próximo evento',
    subtitle: 'Destaque do próximo evento',
    visible: true,
    order: 3,
    content: {},
  },
  {
    id: 'hs-media-feed',
    type: 'mediaFeed',
    title: 'Momentos da Comunidade',
    subtitle: 'Acompanhe nossa vida em comunidade nas redes sociais.',
    visible: true,
    order: 4,
    content: { limit: 6 },
  },
  {
    id: 'hs-recent-posts',
    type: 'recentPosts',
    title: 'Últimas Atividades',
    subtitle: 'Mensagens, devocionais e novidades da comunidade.',
    visible: true,
    order: 5,
    content: {
      posts: [
        {
          id: 'p1',
          title: 'A importância da comunhão na vida cristã',
          category: 'Mensagem',
          author: 'Pr. Marcos Andrade',
          date: '2026-08-05',
          views: 1240,
          likes: 86,
          comments: 12,
          cover: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
        },
        {
          id: 'p2',
          title: 'Resumo do Culto de Batismos nas Águas',
          category: 'Evento',
          author: 'Equipe de Mídia',
          date: '2026-08-02',
          views: 980,
          likes: 64,
          comments: 8,
          cover: 'https://images.unsplash.com/photo-1507692049790-de58290a4334?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
        },
        {
          id: 'p3',
          title: 'Devocional: Descansando em Deus',
          category: 'Devocional',
          author: 'Pr. Rafael Moreira',
          date: '2026-07-30',
          views: 1560,
          likes: 112,
          comments: 21,
          cover: 'https://images.unsplash.com/photo-1544427920-c49ccfb85579?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
        },
        {
          id: 'p4',
          title: 'Encontro de Líderes: Novidades e visão',
          category: 'Células',
          author: 'Coordenação',
          date: '2026-07-19',
          views: 720,
          likes: 45,
          comments: 6,
          cover: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
        },
      ],
    },
  },
  {
    id: 'hs-modules',
    type: 'modules',
    title: 'Conteúdos por Categoria',
    subtitle: 'Módulos temáticos para cada dia da semana.',
    visible: true,
    order: 6,
    content: {
      modules: [
        {
          day: 'Domingo',
          title: 'Culto de Celebração',
          time: '18h30',
          highlight: {
            title: 'A alegria do Senhor é a nossa força',
            desc: 'Mensagem poderosa sobre restauração e esperança.',
            cover: 'https://images.unsplash.com/photo-1507692049790-de58290a4334?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
          },
          links: ['Série: Fundamentos da Fé', 'Testemunhos da semana', 'Escala de louvor'],
        },
        {
          day: 'Quarta-feira',
          title: 'Culto de Oração',
          time: '19h30',
          highlight: {
            title: 'Intercedendo pela cidade',
            desc: 'Noite de oração e clamor por Caratinga.',
            cover: 'https://images.unsplash.com/photo-1544427920-c49ccfb85579?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
          },
          links: ['Pedidos de oração', 'Cadeia de oração', 'Testemunhos de cura'],
        },
        {
          day: 'Sexta-feira',
          title: 'Células & Redes',
          time: '19h30',
          highlight: {
            title: 'Crescendo juntos em comunidade',
            desc: 'Encontros semanais nas casas e redes.',
            cover: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
          },
          links: ['Encontre sua célula', 'Rede Efrata', 'Rede Betel'],
        },
      ],
    },
  },
  {
    id: 'hs-resources',
    type: 'resources',
    title: 'Recursos Rápidos',
    subtitle: 'Ferramentas para sua vida espiritual.',
    visible: true,
    order: 7,
    content: {
      resources: [
        {
          icon: 'heart',
          title: 'Orando com Pr',
          desc: 'Envie seu pedido de oração e receba intercessão.',
          cta: 'Clique aqui',
          tone: 'bg-rose-50 text-rose-600',
          to: '/contato',
        },
        {
          icon: 'play',
          title: 'Cultos Gravados',
          desc: 'Assista às transmissões e mensagens completas.',
          cta: 'Assistir agora',
          tone: 'bg-primary-light text-primary',
          to: '/pregações',
        },
        {
          icon: 'mic',
          title: 'Mensagens em Áudio',
          desc: 'Ouça devocionais e mensagens rápidas.',
          cta: 'Ouvir',
          tone: 'bg-accent-light text-accent-dark',
          to: '/pregações',
        },
      ],
    },
  },
  {
    id: 'hs-banners',
    type: 'banners',
    title: 'Banners de conversão',
    subtitle: 'Inscrição e missões',
    visible: true,
    order: 8,
    content: {
      banners: [
        {
          icon: 'userPlus',
          title: 'Quero me inscrever',
          desc: 'Faça parte da nossa família. Cadastre-se e receba informações sobre células, eventos e novidades.',
          cta: 'Quero me inscrever',
          to: '/celulas',
          tone: 'bg-primary-dark',
        },
        {
          icon: 'gift',
          title: 'Missões',
          desc: 'Cada rede apoia uma missão. Conheça os projetos sociais e veja como sua doação transforma vidas.',
          cta: 'Ver missões',
          to: '/missoes',
          tone: 'bg-accent-dark',
        },
      ],
    },
  },
];


export const church = {
  id: 'church-1',
  name: 'Comunidade Águas Vivas',
  city: 'Caratinga',
  state: 'MG',
  center: { lat: -19.7902, lng: -42.1391 },
};

// Redes (networks) — each supervised by a casal (couple).
export const networks = [
  {
    id: 'net-efrata',
    name: 'Rede Efrata',
    color: '#0284c7',
    mission: 'APAC Caratinga',
    supervisor: {
      id: 'sup-1',
      type: 'casal',
      name: 'Marcos & Priscila Andrade',
      phone: '33991230001',
      avatar: av(11),
      avatar2: av(45),
    },
  },
  {
    id: 'net-betel',
    name: 'Rede Betel',
    color: '#f59e0b',
    mission: 'AMAC',
    supervisor: {
      id: 'sup-2',
      type: 'casal',
      name: 'Rafael & Letícia Moreira',
      phone: '33991230002',
      avatar: av(12),
      avatar2: av(47),
    },
  },
  {
    id: 'net-siao',
    name: 'Rede Sião',
    color: '#0369a1',
    mission: 'Lar dos Idosos Geraldo Sales',
    supervisor: {
      id: 'sup-3',
      type: 'casal',
      name: 'Daniel & Sara Campos',
      phone: '33991230003',
      avatar: av(13),
      avatar2: av(48),
    },
  },
  {
    id: 'net-peniel',
    name: 'Rede Peniel',
    color: '#d97706',
    mission: 'Lar dos Idosos São Vicente de Paula',
    supervisor: {
      id: 'sup-4',
      type: 'casal',
      name: 'Tiago & Ana Ribeiro',
      phone: '33991230004',
      avatar: av(14),
      avatar2: av(49),
    },
  },
];


// Células. address inc. lat/lng for proximity sorting.
export const cells = [
  {
    id: 'cell-1',
    name: 'Célula Restauração',
    networkId: 'net-efrata',
    day: 'Terça-feira',
    time: '19:30',
    address: { street: 'Rua Coronel Pedro Cordeiro', number: '210', neighborhood: 'Centro', city: 'Caratinga', lat: -19.7899, lng: -42.1388 },
    leader: { type: 'casal', name: 'João & Maria Silva', phone: '33998760011', avatar: av(15), avatar2: av(30) },
    host: { name: 'Célia Nogueira', phone: '33998760012', avatar: av(31) },
    inviteText: 'Venha experimentar um tempo de restauração, adoração e comunhão. Traga sua família e convide um amigo!',
  },

  {
    id: 'cell-2',
    name: 'Célula Águas Profundas',
    networkId: 'net-efrata',
    day: 'Quinta-feira',
    time: '20:00',
    address: { street: 'Av. Olegário Maciel', number: '540', neighborhood: 'Dário Grossi', city: 'Caratinga', lat: -19.7845, lng: -42.1442 },
    leader: { type: 'individual', name: 'Fernanda Lopes', phone: '33998760013', avatar: av(16) },
    host: { name: 'Roberto Alves', phone: '33998760014', avatar: av(32) },
    inviteText: 'Mergulhe conosco em um encontro de fé e amizade. Venha conhecer pessoas incríveis e crescer juntos!',
  },

  {
    id: 'cell-3',
    name: 'Célula Semente',
    networkId: 'net-efrata',
    day: 'Sexta-feira',
    time: '19:30',
    address: { street: 'Rua João Pinheiro', number: '88', neighborhood: 'Santa Cruz', city: 'Caratinga', lat: -19.7981, lng: -42.1325 },
    leader: { type: 'casal', name: 'Pedro & Júlia Martins', phone: '33998760015', avatar: av(17), avatar2: av(33) },
    host: { name: 'Vera Lúcia', phone: '33998760016', avatar: av(34) },
  },
  {
    id: 'cell-4',
    name: 'Célula Redenção',
    networkId: 'net-betel',
    day: 'Quarta-feira',
    time: '20:00',
    address: { street: 'Rua Niterói', number: '312', neighborhood: 'Esperança', city: 'Caratinga', lat: -19.7752, lng: -42.1298 },
    leader: { type: 'casal', name: 'Lucas & Camila Reis', phone: '33998760017', avatar: av(18), avatar2: av(35) },
    host: { name: 'Antônio Freitas', phone: '33998760018', avatar: av(36) },
  },
  {
    id: 'cell-5',
    name: 'Célula Farol',
    networkId: 'net-betel',
    day: 'Terça-feira',
    time: '19:00',
    address: { street: 'Rua Bernardo Mascarenhas', number: '77', neighborhood: 'Zacarias', city: 'Caratinga', lat: -19.8021, lng: -42.1451 },
    leader: { type: 'individual', name: 'Gabriel Souza', phone: '33998760019', avatar: av(19) },
    host: { name: 'Marta Dias', phone: '33998760020', avatar: av(37) },
  },
  {
    id: 'cell-6',
    name: 'Célula Vida Nova',
    networkId: 'net-betel',
    day: 'Quinta-feira',
    time: '19:30',
    address: { street: 'Rua Prefeito Coelho', number: '145', neighborhood: 'Limoeiro', city: 'Caratinga', lat: -19.8103, lng: -42.1359 },
    leader: { type: 'casal', name: 'André & Bianca Costa', phone: '33998760021', avatar: av(20), avatar2: av(38) },
    host: { name: 'José Carlos', phone: '33998760022', avatar: av(39) },
  },
  {
    id: 'cell-7',
    name: 'Célula Manancial',
    networkId: 'net-siao',
    day: 'Sexta-feira',
    time: '20:00',
    address: { street: 'Rua Sete de Setembro', number: '400', neighborhood: 'Centro', city: 'Caratinga', lat: -19.7912, lng: -42.1402 },
    leader: { type: 'casal', name: 'Felipe & Nayara Gomes', phone: '33998760023', avatar: av(21), avatar2: av(40) },
    host: { name: 'Isabel Rocha', phone: '33998760024', avatar: av(41) },
  },
  {
    id: 'cell-8',
    name: 'Célula Rocha Eterna',
    networkId: 'net-siao',
    day: 'Quarta-feira',
    time: '19:30',
    address: { street: 'Av. Cônego Lima', number: '620', neighborhood: 'Nossa Senhora Auxiliadora', city: 'Caratinga', lat: -19.7688, lng: -42.1512 },
    leader: { type: 'individual', name: 'Renata Barbosa', phone: '33998760025', avatar: av(22) },
    host: { name: 'Sérgio Pinto', phone: '33998760026', avatar: av(42) },
  },
  {
    id: 'cell-9',
    name: 'Célula Esperança',
    networkId: 'net-peniel',
    day: 'Terça-feira',
    time: '20:00',
    address: { street: 'Rua Maranhão', number: '58', neighborhood: 'Aparecida', city: 'Caratinga', lat: -19.8055, lng: -42.1233 },
    leader: { type: 'casal', name: 'Bruno & Tatiane Melo', phone: '33998760027', avatar: av(23), avatar2: av(43) },
    host: { name: 'Cláudia Ferreira', phone: '33998760028', avatar: av(44) },
  },
  {
    id: 'cell-10',
    name: 'Célula Luz do Mundo',
    networkId: 'net-peniel',
    day: 'Quinta-feira',
    time: '19:00',
    address: { street: 'Rua Espírito Santo', number: '190', neighborhood: 'Doutor Eduardo', city: 'Caratinga', lat: -19.7799, lng: -42.1188 },
    leader: { type: 'individual', name: 'Mateus Azevedo', phone: '33998760029', avatar: av(24) },
    host: { name: 'Elaine Cardoso', phone: '33998760030', avatar: av(46) },
  },
];

const GAL = {
  cell: 'https://images.unsplash.com/photo-1780946101636-00004978f8c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  event: 'https://images.pexels.com/photos/34595035/pexels-photo-34595035.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=800',
  community: 'https://images.unsplash.com/photo-1517456793572-1d8efd6dc135?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
};

export const events = [
  {
    id: 'ev-1',
    title: 'Seminário de Casais — Aliança Restaurada',
    date: '2026-07-12T19:00:00',
    days: '12 a 13 de Julho',
    location: 'Templo Sede — Centro, Caratinga',
    cover: GAL.event,
    totalSlots: 120,
    filledSlots: 86,
    fee: 'R$ 40,00 por casal',
    description:
      'Um fim de semana dedicado a fortalecer a aliança do casamento à luz da Palavra, com palestras, dinâmicas e momentos de oração a dois.',
    subjects: [
      'A base bíblica do casamento',
      'Comunicação e resolução de conflitos',
      'Intimidade e vida espiritual a dois',
      'Construindo um altar familiar',
    ],
    formLink: '',
    formFields: [
      { key: 'cidade', label: 'Cidade', type: 'text', required: true },
      { key: 'faixa_etaria', label: 'Faixa etária', type: 'select', required: true, options: ['18-25', '26-35', '36-45', '46+'] },
      { key: 'transporte', label: 'Precisa de transporte?', type: 'checkbox', required: false, options: ['Sim, preciso de carona', 'Posso oferecer carona'] },
    ],
  },

  {
    id: 'ev-2',
    title: 'Encontro de Líderes de Célula',
    date: '2026-07-19T09:00:00',
    days: '19 de Julho',
    location: 'Salão de Redes — Dário Grossi',
    cover: GAL.community,
    totalSlots: 60,
    filledSlots: 60,
    fee: 'Gratuito',
    description:
      'Encontro de capacitação e comunhão para líderes e futuros líderes de células, com visão, treinamento e troca de experiências.',
    subjects: [
      'Visão e valores da igreja',
      'Como conduzir um encontro de célula',
      'Cuidado pastoral e discipulado',
      'Multiplicação de células',
    ],
    formLink: '',
  },
  {
    id: 'ev-3',
    title: 'Culto de Batismos nas Águas',
    date: '2026-08-02T18:30:00',
    days: '02 de Agosto',
    location: 'Templo Sede — Centro, Caratinga',
    cover: GAL.cell,
    totalSlots: 200,
    filledSlots: 41,
    fee: 'Gratuito',
    description:
      'Celebração especial de batismos nas águas. Venha testemunhar vidas sendo transformadas e, se desejar, agende o seu batismo.',
    subjects: [
      'O significado do batismo',
      'Testemunhos de vida transformada',
      'Celebração e comunhão',
    ],
    formLink: '',
  },
  {
    id: 'ev-4',
    title: 'Conferência de Jovens — Geração Águas Vivas',
    date: '2026-08-23T19:30:00',
    days: '23 a 25 de Agosto',
    location: 'Ginásio Municipal — Caratinga',
    cover: GAL.event,
    totalSlots: 400,
    filledSlots: 210,
    fee: 'R$ 25,00',
    description:
      'Três dias de adoração, palavra e propósito para a juventude. Uma geração chamada para impactar a cidade com o amor de Cristo.',
    subjects: [
      'Identidade e propósito',
      'Vivendo a fé no mundo digital',
      'Amizades e influência',
      'Missão e chamado',
    ],
    formLink: '',
  },
];


export const gallery = [
  { id: 'g1', category: 'celula', cellId: 'cell-1', title: 'Célula Restauração', img: GAL.cell },
  { id: 'g2', category: 'evento', title: 'Culto de Batismos', img: GAL.event },
  { id: 'g3', category: 'rede', title: 'Encontro Rede Efrata', img: GAL.community },
  { id: 'g4', category: 'celula', cellId: 'cell-3', title: 'Célula Semente', img: GAL.community },
  { id: 'g5', category: 'evento', title: 'Conferência de Jovens', img: GAL.event },
  { id: 'g6', category: 'rede', title: 'Rede Betel reunida', img: GAL.cell },
  { id: 'g7', category: 'celula', cellId: 'cell-5', title: 'Célula Farol', img: GAL.event },
  { id: 'g8', category: 'evento', title: 'Seminário de Casais', img: GAL.community },
  { id: 'g9', category: 'rede', title: 'Rede Sião', img: GAL.cell },
  { id: 'g10', category: 'celula', cellId: 'cell-1', title: 'Célula Restauração', img: GAL.community },
  { id: 'g11', category: 'celula', cellId: 'cell-1', title: 'Célula Restauração', img: GAL.event },
  { id: 'g12', category: 'celula', cellId: 'cell-3', title: 'Célula Semente', img: GAL.event },
  { id: 'g13', category: 'celula', cellId: 'cell-5', title: 'Célula Farol', img: GAL.community },
];


// Missões sociais apoiadas pelas redes e pela comunidade.
export const missions = [
  {
    id: 'mis-apac-inhapim',
    name: 'APAC Inhapim',
    networkId: 'net-pedro',
    networkName: 'Rede Pedro',
    category: 'Recuperação',
    description:
      'Apoio à Associação de Proteção e Assistência aos Condenados de Inhapim, promovendo a ressocialização de pessoas em privação de liberdade por meio do trabalho, estudo e fé.',
    needsDonation: false,
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-apac-caratinga',
    name: 'APAC Caratinga',
    networkId: 'net-joao',
    networkName: 'Rede João',
    category: 'Recuperação',
    description:
      'Acompanhamento e apoio à APAC de Caratinga, levando esperança e dignidade a pessoas em processo de recuperação e reintegração à sociedade.',
    needsDonation: false,
    image: 'https://images.unsplash.com/photo-1507692049790-de58290a4334?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-amac',
    name: 'AMAC',
    networkId: 'net-paulo',
    networkName: 'Rede Paulo',
    category: 'Assistência Social',
    description:
      'Apoio à Associação de Amigos do Menor e do Adolescente de Caratinga, cuidando de crianças e adolescentes em situação de vulnerabilidade.',
    needsDonation: false,
    image: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-lar-geraldo-sales',
    name: 'Lar dos Idosos Geraldo Sales',
    networkId: 'net-marcos',
    networkName: 'Rede Marcos',
    category: 'Idosos',
    description:
      'Visitas e apoio ao Lar dos Idosos Geraldo Sales, levando carinho, companhia e cuidado aos nossos queridos idosos.',
    needsDonation: false,
    image: 'https://images.unsplash.com/photo-1517456793572-1d8efd6dc135?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-lar-sao-vicente',
    name: 'Lar dos Idosos São Vicente de Paula',
    networkId: 'net-andre',
    networkName: 'Rede André',
    category: 'Idosos',
    description:
      'Apoio ao Lar dos Idosos São Vicente de Paula, promovendo momentos de comunhão, oração e assistência aos idosos acolhidos.',
    needsDonation: false,
    image: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-sad',
    name: 'SAD',
    networkId: null,
    networkName: null,
    category: 'Assistência Social',
    description:
      'Serviço de Assistência e Desenvolvimento que atende famílias em situação de vulnerabilidade. Precisa de doações para continuar o trabalho.',
    needsDonation: true,
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-nucleo-cancer',
    name: 'Núcleo do Câncer',
    networkId: null,
    networkName: null,
    category: 'Saúde',
    description:
      'Apoio a pacientes oncológicos e seus familiares, oferecendo suporte emocional, espiritual e material. Sua doação faz a diferença.',
    needsDonation: true,
    image: 'https://images.unsplash.com/photo-1507692049790-de58290a4334?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-asadom',
    name: 'Asadom',
    networkId: 'net-tiago',
    networkName: 'Rede Tiago',
    category: 'Assistência Social',
    description:
      'Associação de apoio e desenvolvimento que atende a comunidade com projetos sociais. Acompanhada pela Rede Tiago.',
    needsDonation: false,
    image: 'https://images.unsplash.com/photo-1517456793572-1d8efd6dc135?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-portelinha',
    name: 'Portelinha',
    networkId: 'net-mateus',
    networkName: 'Rede Mateus',
    category: 'Comunidade',
    description:
      'Projeto social na comunidade da Portelinha, levando apoio, ensino e esperança às famílias da região.',
    needsDonation: false,
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-sua-casa-nossa-causa',
    name: 'Sua Casa Nossa Causa',
    networkId: null,
    networkName: null,
    category: 'Habitação',
    description:
      'Projeto de reforma e construção de moradias dignas para famílias em situação de vulnerabilidade. Precisa de doações e voluntários.',
    needsDonation: true,
    image: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
  {
    id: 'mis-pintando-alegria',
    name: 'Pintando Alegria no Bairro',
    networkId: null,
    networkName: null,
    category: 'Comunidade',
    description:
      'Mutirão de pintura e revitalização de espaços comunitários nos bairros, levando cor e alegria às comunidades. Precisa de doações de tinta e voluntários.',
    needsDonation: true,
    image: 'https://images.unsplash.com/photo-1517456793572-1d8efd6dc135?crop=entropy&cs=srgb&fm=jpg&q=85&w=800',
  },
];

// Mock admin user for JWT-style login (frontend only, pre-NestJS).
export const adminUser = {

  id: 'usr-admin',
  name: 'Administrador',
  email: 'admin@aguasvivas.com',
  password: 'admin123',
};

// ---------------------------------------------------------------------------
// PREGAÇÕES — vídeos disponibilizados no YouTube, separados por comunidade.
// ---------------------------------------------------------------------------

export const preachingChannels = [
  {
    id: 'caratinga',
    name: 'Caratinga',
    handle: '@aguasvivascomunidadecaratinga',
    url: 'https://www.youtube.com/@aguasvivascomunidadecaratinga',
    description: 'Pregações e cultos da Comunidade Águas Vivas em Caratinga.',
  },
  {
    id: 'inhapim',
    name: 'Inhapim',
    handle: '@aguasvivascomunidadeinhapim',
    url: 'https://www.youtube.com/@aguasvivascomunidadeinhapim',
    description: 'Pregações e cultos da Comunidade Águas Vivas em Inhapim.',
  },
];

export const preachings = [
  // ---- Caratinga ----
  {
    id: 'pr-car-1',
    channelId: 'caratinga',
    title: 'A alegria do Senhor é a nossa força',
    preacher: 'Pr. Marcos Andrade',
    date: '2026-08-02',
    duration: '48:12',
    views: 1240,
    videoId: 'dQw4w9WgXcQ',
    series: 'Fundamentos da Fé',
    description:
      'Mensagem poderosa sobre restauração e esperança, ministrada no culto de celebração.',
  },
  {
    id: 'pr-car-2',
    channelId: 'caratinga',
    title: 'Intercedendo pela cidade',
    preacher: 'Pr. Rafael Moreira',
    date: '2026-07-29',
    duration: '52:40',
    views: 980,
    videoId: '9bZkp7q19f0',
    series: 'Culto de Oração',
    description:
      'Noite de oração e clamor por Caratinga, com ministração da Palavra.',
  },
  {
    id: 'pr-car-3',
    channelId: 'caratinga',
    title: 'Crescendo juntos em comunidade',
    preacher: 'Pr. Marcos Andrade',
    date: '2026-07-26',
    duration: '45:03',
    views: 1560,
    videoId: 'kJQP7kiw5Fk',
    series: 'Células & Redes',
    description:
      'Ensinamento sobre a importância da comunhão e do crescimento em comunidade.',
  },
  {
    id: 'pr-car-4',
    channelId: 'caratinga',
    title: 'O significado do batismo nas águas',
    preacher: 'Pr. Daniel Campos',
    date: '2026-07-19',
    duration: '39:55',
    views: 720,
    videoId: 'fJ9rUzIMcZQ',
    series: 'Culto de Batismos',
    description:
      'Celebração especial de batismos nas águas com ministração sobre o seu significado.',
  },
  {
    id: 'pr-car-5',
    channelId: 'caratinga',
    title: 'Identidade e propósito',
    preacher: 'Pr. Tiago Ribeiro',
    date: '2026-07-12',
    duration: '50:18',
    views: 1105,
    videoId: 'YQHsXMglC9A',
    series: 'Conferência de Jovens',
    description:
      'Mensagem para a juventude sobre identidade, chamado e propósito em Cristo.',
  },
  {
    id: 'pr-car-6',
    channelId: 'caratinga',
    title: 'A base bíblica do casamento',
    preacher: 'Pr. Marcos Andrade',
    date: '2026-07-05',
    duration: '55:21',
    views: 890,
    videoId: 'OPf0YbXqDm0',
    series: 'Seminário de Casais',
    description:
      'Palestra do Seminário de Casais sobre a aliança do casamento à luz da Palavra.',
  },

  // ---- Inhapim ----
  {
    id: 'pr-inh-1',
    channelId: 'inhapim',
    title: 'Esperança que não decepciona',
    preacher: 'Pr. André Costa',
    date: '2026-08-01',
    duration: '47:30',
    views: 860,
    videoId: 'JGwWNGJdvx8',
    series: 'Culto de Celebração',
    description:
      'Mensagem de esperança e fé ministrada no culto de celebração em Inhapim.',
  },
  {
    id: 'pr-inh-2',
    channelId: 'inhapim',
    title: 'Orando sem cessar',
    preacher: 'Pr. Felipe Gomes',
    date: '2026-07-28',
    duration: '44:12',
    views: 640,
    videoId: 'e-ORhEE9VVg',
    series: 'Culto de Oração',
    description:
      'Noite de oração e intercessão com ensinamento sobre a vida de oração.',
  },
  {
    id: 'pr-inh-3',
    channelId: 'inhapim',
    title: 'Fé que move montanhas',
    preacher: 'Pr. André Costa',
    date: '2026-07-25',
    duration: '51:08',
    views: 1120,
    videoId: 'RgKAFK5djSk',
    series: 'Fundamentos da Fé',
    description:
      'Ensinamento sobre a fé que transforma vidas e move montanhas.',
  },
  {
    id: 'pr-inh-4',
    channelId: 'inhapim',
    title: 'Comunhão e unidade do corpo',
    preacher: 'Pr. Bruno Melo',
    date: '2026-07-18',
    duration: '42:45',
    views: 530,
    videoId: 'C0DPdy98e4c',
    series: 'Células & Redes',
    description:
      'Mensagem sobre a importância da comunhão e da unidade na igreja.',
  },
  {
    id: 'pr-inh-5',
    channelId: 'inhapim',
    title: 'Vivendo a fé no mundo digital',
    preacher: 'Pr. Mateus Azevedo',
    date: '2026-07-11',
    duration: '49:36',
    views: 975,
    videoId: 'hHW1oY26kxQ',
    series: 'Conferência de Jovens',
    description:
      'Mensagem para a juventude sobre como viver a fé em um mundo cada vez mais digital.',
  },
  {
    id: 'pr-inh-6',
    channelId: 'inhapim',
    title: 'Intimidade e vida espiritual a dois',
    preacher: 'Pr. André Costa',
    date: '2026-07-04',
    duration: '53:14',
    views: 710,
    videoId: '8jPQjjsBbIc',
    series: 'Seminário de Casais',
    description:
      'Palestra sobre intimidade e vida espiritual no casamento.',
  },
];


